import styled from 'styled-components';
import DefaultContentLoader from 'react-content-loader';
import { ComponentProps } from './types';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  height: 4.5rem;
`;

// TODO: TFR-45:ContentLoader make unique name or do not export
export const ContentLoader = styled(DefaultContentLoader)<ComponentProps>`
  width: 100%;
  opacity: ${(props) => props.$opacity};
`;
